import React from 'react';
import { useHistory /*, useLocation*/ } from 'react-router-dom';
const PageNotFound = function () {
    const history = useHistory();
    //const location = useLocation();
    function gotoHome(e) {
        e.preventDefault();
        history.push({ pathname: '/' });
    }
    return (
        <div id="login-container">
            <h1 className="h2 text-dark text-center push-top-bottom animation-slideDown">
                <i className="fa fa-cube"></i> <strong>Opps!</strong>
            </h1>
            <h3 className="h1 text-dark text-center animation-slideDown">404 Page not found</h3>
            <div className="block animation-fadeInQuickInv">
                <div className="form-group form-actions">
                    <div className="col-xs-12 text-center pad-20 ">
                        <button
                            type="submit"
                            onClick={gotoHome}
                            className="btn btn-effect-ripple btn-lg btn-primary1 login-btn-wdth mar-20">
                            <strong> Go to Home </strong>
                        </button>
                    </div>
                </div>
            </div>
            <footer className="text-muted text-center animation-pullUp">
                <small>
                    <span id="year-copy"></span> &copy; AllinTheLoop
                </small>
            </footer>
        </div>
    );
};
export default PageNotFound;
